import * as service from './PersonalInfo.service'
export default {
  data() {
    return {
      foofkey:0,
      imgSrc: '',
      suitsize: [],
      fileImg: '',
      personalForm: {
        FirstName: '',
        LastName: '',
        MiddleName: '',
        Email: '',
        Gender: '',
        DOB: '',
        SSN: '',
        AlternativeEmail: '',
        Notes: '',
        PhoneNumber: '',
        SuitSize: '',
        TShirtSize: '',
        ShortsSize: '',
        HomeNumber: '',
        Address: '',
        City: '',
        State: '',
        IsAppUser: '',
        /*   UserZone:'',
         UserOffset:'',*/
        CountryTimeZoneId: '',
        Zip: ''
      },
      onRequest: false,
      licenceActive: '',
      imgPath: '',
      imgDataUrl: '',
      show: false,
      persBackup: {},
      states: [],
      timezones: [],
      ButtonConfig: [],
      currentRole: '',
      rules: {


        AlternativeEmail: [{
            type: 'email',
            message: 'Invalid Email Id'
          },

        ]
      }


    }
  },

  
  mounted() {
    this.currentRole = authDetails.role
    /* FG - FOOF - Jun 2 2019... commented out stuff below.
    if (!this.data.isEdit) {
      this.personalForm.FirstName = this.data.firstName ? this.data.firstName : ''
      this.personalForm.LastName = this.data.lastName ? this.data.lastName : ''
      this.personalForm.Email = this.data.email ? this.data.email : ''
    }
    */
    // this.ButtonConfig=this.data; //FG - FOOF - Jun 2 2019 - THIS HAD BEEN COMMENTED OUT IN THE ORIGINAL CODE... ITS NOT ME

    this.suitSize()
    this.getStates()
    this.getTimeZone()
  },
  props: ['data', 'editShow'],
  watch: {

    data: function () {
      this.persBackup = deepcopy(this.data.response)

      this.personalForm = this.persBackup

      if (this.personalForm["UserZone"]) {
        var xsm = this.personalForm["UserZone"].substring(0, 1)
        if (xsm != '-') {

          this.personalForm["UserZone"] = '+ ' + this.personalForm["UserZone"].substring(0, this.personalForm["UserZone"].length - 1);
        }
        if (xsm == '-') {
          this.personalForm["UserZone"] = this.personalForm["UserZone"].charAt(0) + " " + this.personalForm["UserZone"].substr(1)
        }
      }

      this.LicenceCheck()
      this.personalForm['Email'] = deepcopy(this.data.response.PrimaryEmail)
      this.persBackup.ImagePath ? this.imgSrc = baseUrl + 'Documents/ProfilePics/' + this.persBackup.ImagePath : this.imgSrc = 'static/images/Default-avatar.jpg'
      this.persBackup.ImagePath ? this.imgPath = baseUrl + 'Documents/ProfilePics/' + this.persBackup.ImagePath : this.imgPath = 'static/images/Default-avatar.jpg'

    }

  },

  methods: {
    LicenceCheck() {
      let context = this


      service.LicenceCheck().then(function (response) {
        context.licenceActive = response

      }).catch((error) => {

      })


    },

    getStates() {
      loader.startLoader()
      let context = this
      service.GetStates().then(function (response) {

        context.states = response
        loader.stopLoader()

      }, (error) => {

        context.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
        loader.stopLoader()

      })

    },

    getTimeZone() {
      loader.startLoader()
      let context = this
      service.GetCountryTimeZone().then(function (response) {

        context.timezones = response
        loader.stopLoader()

      }, (error) => {

        context.$notify({

          title: 'Error',

          message: error.responseJSON.Message,

          type: 'error'

        })
        loader.stopLoader()

      })

    },


    modalCancel() {
      if ($('#PostsignupModel').length > 0) {
        $('#PostsignupModel').modal('hide')
      } else {
        this.personalForm = deepcopy(this.data.response)
        this.personalForm['Email'] = deepcopy(this.data.response.PrimaryEmail)
      }
       //FG - FOOF - Jun 2 2019 changed line below, it used to set isEdit to true... 
       //     that didn't seem right
       //     ALSO the line below used to be in the "else block" just above but I make sure
       //     isEdit is false regardless of anything else if the update is cancelled
       this.data['isEdit'] = false //if the update is cancelled then go back to view instead of edit
    },
    setImage(e) {
      let context = this
      const file = e.target.files[0]
      this.fileImg = e.target.files[0]

      if (!file.type.includes('image/jpeg') && !file.type.includes('image/jpg') && !file.type.includes('image/png')) {
        return
      }
      if (file.size > 200000) {
        alert('You have exceeded the maximum image size of 200 Kb')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()

        reader.onload = (event) => {
          this.imgSrc = event.target.result
          this.imgPath = event.target.result

          var image_arr = {}
          var image_data = new FormData()

          image_arr['Username'] = context.personalForm.Email
          image_arr['ProfilePic'] = context.fileImg

          for (var key in image_arr) {
            image_data.append(key, image_arr[key])
          }

          loader.startLoader()

          service.UpdateUserImage(image_data).then(function (response) {

            //FG - FOOF - 20200902-FG-001
            //ONLY UPDATE THE authDetails IF THE IMAGE THAT WAS UPDATED IS FOR THE
            //SIGNED ON USER (I.E. THE USER THAT IS REPRESENTED IN authDetails)
            //I ADDED THE CONDITION BELOW 
            if(context.data.response.PersonnelId == authDetails.PersonnelId) {
              let pic1 = response.replace(/([a-z])([A-Z])/, '$1 $2')
              let pic2 = pic1.replace(/\n/g, ' ')

              let pic3 = pic2.split(' ')

              authDetails['ImageName'] = pic3[6]
              authDetails['IsFirstLogin'] = 'False'

              context.$localStorage.set('authentication', JSON.stringify(authDetails))
            }
            //END OF FIX 20200902-FG-001 
            context.$notify({

              title: 'Success',

              message: 'Profile Image Updated',

              type: 'success'

            })
            context.$router.app.$emit('reloadAuth')
            loader.stopLoader()

          }, (error) => {

            context.$notify({

              title: 'Error',

              message: error.responseJSON.Message,

              type: 'error'

            })
            loader.stopLoader()

          })

        }

        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },

    backProfile() {
      this.$router.push('/addpersonnel')

    },

    cEdit() {
      if (this.data["isEdit"] == true) {
        this.data["isEdit"] = false
      } else if (this.data["isEdit"] == false) {
        this.data["isEdit"] = true
      }

      setTimeout(function () {
        var x = $('#time-offset').val()
        $('#time-offset').mask("_ xy:ab", {

          translation: {
            '_': {
              pattern: /[+|-]/,
              optional: false
            },
            'x': {
              pattern: /[0-1]/,
              optional: false
            },
            'y': {
              pattern: /[0-9]/,
              optional: false
            },
            'a': {
              pattern: /[0-5]/,
              optional: false
            },
            'b': {
              pattern: /[0-9]/,
              optional: false
            }
          },
          onComplete: function (cep) {
            var l = cep.substring(2, 7);
            var sym = cep.substring(0, 1)
            var xp = l.split(":");
            if (parseInt(xp[0]) == 14) {

              if (parseInt(xp[1]) > 0) {
                $('#time-offset').val(sym + ' 14:00');
              }

            }
          },
          placeholder: "_ __:__"

        })
        $('#time-offset').val(x)
      })

    },

    suitSize() {

      for (var i = 26; i < 46; i++) {
        this.suitsize.push({
          label: i,
          value: i
        })
        i = i + 1;
      }
    },


    updatePersonnel(formName) {
      let context = this
      //Make sure the date of birth is in the correct format
      if (context.personalForm.DOB) {
        context.personalForm['DOB'] = this.$moment(context.personalForm['DOB']).format('MM-DD-YYYY')
      }
      //Validate the data that is on the form
      this.$refs[formName].validate((valid) => {
        if (valid) {
          loader.startLoader()
          this.onRequest = true
          var tempPersonal = {}
          for (var key in context.personalForm) {
            if (context.personalForm.hasOwnProperty(key)) {;
              if (context.personalForm[key] && key !== 'PersonnelEmergency') {
                tempPersonal[key] = context.personalForm[key]
              }
            }
          }
          //Send the data to the server to update the database
          service.PersonnelPostSignUp(tempPersonal).then(function (response) {

            //FG - FOOF - After Cert - First Release Security - added conditional statement below
            //ADDED AFTER SERVER SIDE SECURITY WAS IN PLACE - SERVER SIDE SECURITY CHECK EXAMPLE
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {          
              context.onRequest = false
              loader.stopLoader()
              return;
            }
            context.onRequest = false
            //FG - FOOF - 20200902-FG-001
            //Update the local data that is displayed for the signed on user (i.e.
            //The image that is displayed, the name that is displayed etc. 
            //BUT ONLY IF
            //it is that signed on user that was just updated.
            //I ADDED THE CONDITION BELOW -- to be sure this info is changed locally
            //only if it is for the signed on user.
            if(context.data.response.PersonnelId == authDetails.PersonnelId) {
              authDetails['IsFirstLogin'] = 'False'
              authDetails['FirstName'] = context.personalForm.FirstName
              authDetails['LastName'] = context.personalForm.LastName
              context.$localStorage.set('authentication', JSON.stringify(authDetails))
              context.$router.app.$emit('reloadAuth') //FG - FOOF - 20200902-FG-001 - also added this line                        
            }
            //FG - FOOF - END FIX -20200902-FG-001

            //FG - FOOF - AFTER CERT - First Release Security - seems the broadcast below is not needed
            //            AND when it is in place causes problems
            //context.$router.app.$emit('updatedinfo')
            
            context.data['isEdit'] = false //FG - FOOF - jun 2 2019 - this used to set isEdit to true
            context.$notify({title: 'Success', message: 'Personnel Details Updated', type: 'success'})
            context.$router.app.$emit('reloadAuth') 
            loader.stopLoader()
          }, (error) => {
            context.onRequest = false
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
            loader.stopLoader()
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/PersonalInfo/PersonalInfo.controller.js